/** Communication badge keys persisted in student_badges_state (ai-tutor-service). */
export const COMM_BADGE_KEYS = {
  FIRST_PRACTICE: 'first_practice',
  STREAK_3: 'streak_3',
  TAMIL_SPEAKER: 'tamil_speaker',
} as const;

export type CommBadgeItem = {
  badge_key?: string;
  earned_at?: string;
};

/** i18n key for a communication badge title (gamification.badges.*). */
export function communicationBadgeTitleKey(badgeKey: string | undefined): string {
  const key = String(badgeKey || '').trim();
  const map: Record<string, string> = {
    [COMM_BADGE_KEYS.FIRST_PRACTICE]: 'gamification.badges.firstPractice',
    [COMM_BADGE_KEYS.STREAK_3]: 'gamification.badges.streak3',
    [COMM_BADGE_KEYS.TAMIL_SPEAKER]: 'gamification.badges.tamilSpeaker',
  };
  return map[key] ?? 'gamification.badges.unknown';
}

export type VocabularyMilestone = {
  id: string;
  titleKey: string;
  descriptionKey: string;
  earned: boolean;
};

/** Client-side vocabulary milestones from existing journey/summary metrics. */
export function computeVocabularyMilestones(
  wordsMastered: number,
  practiceStreak: number
): VocabularyMilestone[] {
  return [
    {
      id: 'words_5',
      titleKey: 'gamification.milestones.words5.title',
      descriptionKey: 'gamification.milestones.words5.description',
      earned: wordsMastered >= 5,
    },
    {
      id: 'words_10',
      titleKey: 'gamification.milestones.words10.title',
      descriptionKey: 'gamification.milestones.words10.description',
      earned: wordsMastered >= 10,
    },
    {
      id: 'words_25',
      titleKey: 'gamification.milestones.words25.title',
      descriptionKey: 'gamification.milestones.words25.description',
      earned: wordsMastered >= 25,
    },
    {
      id: 'streak_3',
      titleKey: 'gamification.milestones.streak3.title',
      descriptionKey: 'gamification.milestones.streak3.description',
      earned: practiceStreak >= 3,
    },
    {
      id: 'streak_7',
      titleKey: 'gamification.milestones.streak7.title',
      descriptionKey: 'gamification.milestones.streak7.description',
      earned: practiceStreak >= 7,
    },
  ];
}
